import { render, staticRenderFns } from "./refund.vue?vue&type=template&id=372d0a2a&"
import script from "./refund.vue?vue&type=script&lang=js&"
export * from "./refund.vue?vue&type=script&lang=js&"
import style0 from "./refund.vue?vue&type=style&index=0&id=372d0a2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AffiliatorTicket: require('/opt/airport.kg/src/components/affiliator/ticket.vue').default,Sulu: require('/opt/airport.kg/node_modules/razlet-sulu-sdk/src/components/index.vue').default})
